import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-Policy',
  templateUrl: 'privacyPolicy.html'
})
export class privacyPolicyComponent implements OnInit{

  PresentDate 
  
  constructor() {
    
    let Todaydate = new Date();
    this.PresentDate=Todaydate.getFullYear()
    }
    ngOnInit(){
    
    }
    
}